import { render, staticRenderFns } from "./SpecialView.vue?vue&type=template&id=3555a829&scoped=true"
import script from "./SpecialView.vue?vue&type=script&lang=js"
export * from "./SpecialView.vue?vue&type=script&lang=js"
import style0 from "./SpecialView.vue?vue&type=style&index=0&id=3555a829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3555a829",
  null
  
)

export default component.exports